import styled from "@emotion/styled";
import { fontFredoka } from "@product/scmp-sdk";

import { Button } from "scmp-app/components/posties/button";

import IconTick from "./icon-tick.svg";

type ContainerProps = {
  $isShow: boolean;
};
export const Container = styled.div<ContainerProps>`
  display: ${props => (props.$isShow ? "flex" : "none")};
  flex-direction: column;
  justify-content: space-between;

  padding-block-end: calc(118px + 48px);
`;

export const Wrapper = styled.div`
  flex: 1;

  padding-inline: 24px;

  ${props => props.theme.breakpoints.up("desktop")} {
    padding-inline: 32px;
  }
`;

export const Question = styled.div`
  margin-block-end: 24px;

  font-weight: 600;
  font-size: 16px;
  font-family: ${fontFredoka};
  line-height: 19.2px;
  text-align: start;

  ${props => props.theme.breakpoints.up("desktop")} {
    font-size: 24px;
    line-height: 28.8px;
  }
`;

export const StyledPostiesQuizAnswers = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  ${props => props.theme.breakpoints.up("desktop")} {
    gap: 8px;
  }
`;

type ActionButtonsProps = {
  $isCorrect: boolean | null;
};
export const ActionButtons = styled.div<ActionButtonsProps>`
  position: absolute;
  inset-block-end: -6px;

  display: flex;
  gap: 16px;
  justify-content: space-between;
  align-items: center;

  inline-size: 100%;
  padding-block: 20px;
  padding-inline: 32px;

  background-color: ${props =>
    // eslint-disable-next-line unicorn/no-nested-ternary
    props.$isCorrect ? "#e5ed8a" : props.$isCorrect === false ? "#ffdbdb" : "#FFFFFF"};

  ${props => props.theme.breakpoints.up("desktop")} {
    padding: 32px;
  }
`;

export const StyledButton = styled(Button)`
  inline-size: 154px;
  padding-block: 12px 13px;

  font-size: 16px;
  line-height: 18px;
  letter-spacing: 3%;

  ${props => props.theme.breakpoints.up("desktop")} {
    inline-size: 154px;
    padding-block: 14px 16px;

    font-size: 18px;
  }
`;

export const DisplayMessage = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`;

export const DisplayMessageText = styled.div`
  display: none;
  ${props => props.theme.breakpoints.up("desktop")} {
    display: block;

    font-weight: 600;
    font-size: 24px;
    font-family: ${fontFredoka};
    line-height: 26.4px;
  }
`;

export const StyledIconTick = styled(IconTick)`
  inline-size: 44px;
  block-size: 36px;
  ${props => props.theme.breakpoints.up("desktop")} {
    inline-size: 52px;
    block-size: 42px;
  }
`;
